import { createFileRoute, redirect } from "@tanstack/react-router";

/** @public */
export const Route = createFileRoute("/optin")({
    beforeLoad: () => {
        throw redirect({ to: "/opt-in" });
    },
});
